var alert_styles = {
  container: {
    display: "flex",
    padding: "8px 16px 8px 12px",
    alignItems: "flex-start",
    gap: "12px",
    alignSelf: "stretch",
    borderRadius: "4px",
    background: "var(--White, #FFF)",
    color: "var(--Red---200, #DC5020)",
  },
  container_custom: {
    display: "flex",
    padding: "8px 16px 8px 12px",
    alignItems: "flex-start",
    gap: "12px",
    alignSelf: "stretch",
    borderRadius: "4px",
    background: "var(--White, #FFF)",
  },
  alert_icon_container: {
    display: "flex",
    width: "20px",
    height: "20px",
    padding: "2.5px",
    justifyContent: "center",
    alignItems: "center",
  },

  alert_text: {
    display: "flex",
    width: "1073px",
    flexDirection: "column" as const,
    justifyContent: "center",
    alignSelf: "stretch",
    color: "var(--Red---200, #DC5020)",
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
  },

  alert_text_custom: {
    display: "flex",
    // width: "1073px",
    flexDirection: "column" as const,
    justifyContent: "center",
    alignSelf: "stretch",
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
  },
};

export default alert_styles;